// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-progress-circular[data-v-ae46235c]{margin:1rem;color:#f96332}", ""]);
// Exports
module.exports = exports;
